import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ImageStylePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ImageStylePopup" */ './Container'),
  'popup'
);
